import { useState, useEffect, useRef } from "react";
import { createRoot } from 'react-dom/client';

import {
    Button,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

import * as commonFunc from 'scripts/common';

var modalRoot;

export default function ADialogPlayerFrag({ tenantFile, path, withCache }) {
    // Hooks React : 
    const [playerStatus, setPlayerStatus] = useState("closed");

    const src = useRef(null);


    useEffect(() => {
        return (() => {
            if (modalRoot) {
                modalRoot.unmount();
                modalRoot = null;
            }
            setPlayerStatus("closed");
        })
    }, []);

    // Constantes Internes :
    const e = tenantFile;
    const reqFile = {
        fileId: e.idFile,
        fileName: e.name,
        container: e.rootContainer,
        etag: e.etag,
        accessToken: e.absoluteUri,
        newWindow: false
    }

    // Fonctions :

    const openModal = () => {
        setPlayerStatus("open");
        modalRoot = createRoot(document.createElement('div'));
        modalRoot.render(<PlayerModal title={reqFile.fileName} size={e.length} src={src} extFile={tenantFile} path={path} withCache={withCache} modalOpt={{ noScroll: true }} callback={() => {
            if (modalRoot) {
                modalRoot.unmount();
                modalRoot = null;
            }
            setPlayerStatus("closed");
        }} />);
    }

    return (
    /* Style à changer */<div className="d-flex justify-content-center align-items-center bg-light rounded shadow" style={{ background: "#FFFFFF" }}>
            <Button
                disabled={playerStatus === "open"}
                className="d-flex align-items-center justify-content-center m-0 p-0" color="dark"
                style={{ width: "25px", height: "25px" }}
                onClick={() => openModal()}
            >
                <i className="fa fa-sm fa-play m-0" />
            </Button>
        </div>
    )
}
function PlayerModal({ title, size, src, extFile, path, withCache, modalOpt, callback }) {
    // Hooks React :
    const playerRef = useRef(null);
    const [modalSrc, setModalSrc] = useState(src.current);

    // Effects :
    useEffect(() => {
        if (!src.current) {
            commonFunc.getFile(path, null).then(async (response) => {
                const finalSrc = URL.createObjectURL(response.data);
                if (withCache) src.current = finalSrc;
                setModalSrc(finalSrc);
            });
        }
        return (() => {
            if (playerRef.current) {
                playerRef.current.pause()
                playerRef.current.currentTime = 0;
                playerRef.current.src = '';
                playerRef.current.load();
                playerRef.current = null;
                if (callback) callback();
            }
        })
    }, []);

    useEffect(() => {
        if (modalSrc && playerRef.current) playerRef.current.play();
    }, [modalSrc]);
    

    return (
        <Modal isOpen={true} className={`modal-player ${modalOpt?.noScroll ? "modal-noscroll" : ""}`} size="lg" scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title} ({commonFunc.bytesToSize(size, 1)})</ModalHeader>
            <ModalBody className="px-2" style={{ overflowX: "hidden" }}>
                <div className="d-block justify-content-center bg-light rounded shadow" style={{ background: "#FFFFFF" }}>
                    <div className="d-flex justify-content-center" style={{ justifySelf: "center" }}>
                        <video controls className="" style={{ width: "100%" }} ref={playerRef} src={modalSrc}
                            onLoadedData={() => { if (playerRef.current) playerRef.current.play(); } }></video>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>{"Fermer"}</Button>
            </ModalFooter>
        </Modal>
    );
}